'use client'

import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    SxProps,
    TablePagination,
    Typography,
} from '@mui/material';
import { numberFormat } from '../../utils/common';
import { TablePaginationActions } from '../table/tableCustom';

type CustomPaginationProps = {
    totalItems: number;
    page: number;
    pageLimit: number;
    setPage: (page: number) => void;
    setPageLimit: (page: number) => void;
    hidden_total?: boolean;
    sxContainer?: SxProps;
};

const CustomPagination: React.FC<CustomPaginationProps> = ({
    totalItems,
    page,
    pageLimit,
    setPage,
    setPageLimit,
    hidden_total,
    sxContainer
}) => {
    const { t } = useTranslation();
    // const pageCount = Math.ceil(totalItems / pageLimit);

    const defaultLabelDisplayedRows = () => {
        // const from = page * pageLimit - pageLimit + 1
        // const to = page * pageLimit
        const count = Number(totalItems)
        // return `${numberFormat(from, 0, 0)}-${count <= to ? numberFormat(count, 0, 0) : numberFormat(to, 0, 0)} ${t('PAGINATION.LIST')} ${t('PAGINATION.FROM')} ${numberFormat(count, 0, 0)} ${t('PAGINATION.LIST')}`
        return <Typography component={'span'} fontSize={14} sx={(theme) => ({
            color: 'black'
        })}>{t("จำนวน {{total}}", { total: numberFormat(count, 0, 0) })}</Typography>
    }

    const handleChangePage = (_: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setPageLimit(parseInt(event.target.value, 10))
        setPage(1)
    }
    return (
        <Box sx={{ width: '100%', ...sxContainer }}>
            <TablePagination
                component="div"
                rowsPerPageOptions={hidden_total ? [] : [5, 10, 15, 100]}
                count={totalItems || 0}
                rowsPerPage={pageLimit}
                page={page}

                labelRowsPerPage={hidden_total ? "" : <Typography
                    component={'span'}
                    fontSize={14}
                    sx={(theme) => ({
                        color: 'black'
                    })}
                >{t("จำนวนต่อหน้า")}</Typography>}


                // labelRowsPerPage={t('')}
                SelectProps={{
                    inputProps: {
                        // 'aria-label': 'จำนวนต่อหน้า'
                    },
                    sx: {
                        color: 'black'
                    },
                    native: true
                }}
                labelDisplayedRows={defaultLabelDisplayedRows}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
                sx={{
                    flex: 'none',
                    // 👇 แก้ตัวเลขที่หายไป (Select + Icon)
                    // '& .MuiTablePagination-selectLabel': {
                    //     color: (theme) => mode === 'dark' ? theme.palette.text.primary : theme.palette.text.secondary,
                    // },
                    // '& .MuiSelect-select': {
                    //     color: (theme) => mode === 'dark' ? theme.palette.text.primary : theme.palette.text.secondary,
                    // },
                    // '& .MuiSelect-icon': {
                    //     color: (theme) => mode === 'dark' ? theme.palette.text.primary : theme.palette.text.secondary,
                    // },
                }}
            />
        </Box >
    );
};

export default CustomPagination;